import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { ToastTypesEnum } from '../enums/toast.enum';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerInterceptor implements HttpInterceptor {
  toastr = inject(ToastrService);
  constructor(private translate: TranslateService) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError((error) => this.errorHandler(error)));
  }

  private errorHandler(response: HttpEvent<any>): Observable<HttpEvent<any>> {
    const errors: any[] = (response as any).error.errors ?? [];
    if(!errors.length) {
      this.toastr.show(this.translate.instant('messages.something_went_wrong'),  ToastTypesEnum.ERROR);
    } else {
      errors.forEach(error => {
        this.toastr.show(error.message, ToastTypesEnum.ERROR);
      });
    }

    throw response;
  }
}

